<template>
  <span :id="id" class="form__title">{{ text }}</span>
</template>

<script>
export default {
  name: 'Title',
  props: {
    id: {
      type: String,
      defaultValue: ''
    },
    text: {
      text: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &__title {
    font-size: 1.2rem;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.114rem;
    @media (min-width: media('tablet')) {
      font-weight: bolder;
    }
  }
}
</style>
